import React, { useLayoutEffect, useRef, useState } from 'react';
// import { flushSync } from 'react-dom';
import { HashRouter, Routes, Route, useLocation } from 'react-router-dom';
import ScrollToTop from './components/other/ScrollToTop';
// import PortalNav from './components/other/PortalNav';
import PortalNavOrders from './components/other/PortalNavOrders';
import DraftOrdersListPage from './pages/DraftOrdersListPage';
import DraftOrderDetailPage from './pages/DraftOrderDetailPage';
import OrdersListPage from './pages/OrdersListPage';
import OrderDetailPage from './pages/OrderDetailPage';

function isDetailPath(pathname) {
  return pathname.startsWith('/draft-order/') || pathname.startsWith('/order/');
}

// function prefersReducedMotion() {
//   return (
//     typeof window !== 'undefined' &&
//     window.matchMedia('(prefers-reduced-motion: reduce)').matches
//   );
// }

// function TransitionRoutes() {
//   const location = useLocation();
//   const [displayLocation, setDisplayLocation] = useState(location);
//   const displayedPathRef = useRef(location.pathname);

//   useLayoutEffect(() => {
//     if (location.pathname === displayedPathRef.current) {
//       setDisplayLocation((prev) => (prev === location ? prev : location));
//       return;
//     }

//     displayedPathRef.current = location.pathname;
//     document.documentElement.dataset.portalNav = isDetailPath(location.pathname)
//       ? 'forward'
//       : 'back';
//     document.documentElement.classList.add('portal-vt');

//     const update = () => flushSync(() => setDisplayLocation(location));
//     const cleanup = () => {
//       document.documentElement.classList.remove('portal-vt');
//       delete document.documentElement.dataset.portalNav;
//     };

//     if (typeof document.startViewTransition === 'function' && !prefersReducedMotion()) {
//       document.startViewTransition(update).finished.finally(cleanup);
//     } else {
//       update();
//       cleanup();
//     }
//   }, [location]);

//   return (
//     <div className="portal-view">
//       <Routes location={displayLocation}>
//         <Route path="/" element={<DraftOrdersListPage />} />
//         <Route path="/draft-order/:orderId" element={<DraftOrderDetailPage />} />
//         <Route path="/orders" element={<OrdersListPage />} />
//         <Route path="/order/:orderId" element={<OrderDetailPage />} />
//       </Routes>
//     </div>
//   );
// }



function App() {
  return (
    <HashRouter>
      <ScrollToTop />
      <PortalNavOrders />
      {/* <TransitionRoutes /> */}
      <Routes >
        <Route path="/" element={<DraftOrdersListPage />} />
        <Route path="/draft-order/:orderId" element={<DraftOrderDetailPage />} />
        <Route path="/orders" element={<OrdersListPage />} />
        <Route path="/order/:orderId" element={<OrderDetailPage />} />
      </Routes>
    </HashRouter>
  );
}

export default App;
